export const authCallbackPage = () =>
  import("./AuthCallbackPage").then((m) => ({ Component: m.AuthCallbackPage }));
